module.exports = __webpack_public_path__ + "static/media/solo-card-2-points.0cda7046.png";